import { IFilial } from 'src/utils/declarations';
import { CitiesActions, CitiesActionTypes } from '../actions';

export interface State {
  cities: Array<any>;
}

export const initialState: State = {
  cities: [],
};

export function reducer(
  state: State = initialState,
  action: CitiesActions
): State {
  switch (action.type) {
    case CitiesActionTypes.GET_CITIES_SUCCESS: {
      return {
        ...state,
        cities: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export const getCities = (state: State) => state.cities;
